// Firebase v8. Production by default; with REACT_APP_USE_EMULATOR=true only
// the emulators of the demo project (demo-gastronaut): over HTTP on one host,
// or with REACT_APP_EMULATOR_ORIGIN behind one HTTPS test-stand origin. See
// utils/emulatorTransport.ts; a misconfigured emulator build stops, it never
// reaches production.
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/functions';
import 'firebase/messaging';
import { connectEmulators, emulatorAppConfig, emulatorPlan, emulatorProjectFor } from './emulatorTransport';

const plan = emulatorPlan(process.env, window.location.origin);
const USE_EMU = plan.kind !== 'production';
const EMULATOR_PROJECT_ID = USE_EMU ? emulatorProjectFor(process.env) : null;

const prodConfig = {
  apiKey: process.env?.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env?.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env?.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env?.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env?.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env?.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env?.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env?.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Emulators: always the demo project (as seeded), dummy keys.
const config = USE_EMU ? emulatorAppConfig(plan, EMULATOR_PROJECT_ID) : prodConfig;

if (!firebase.apps || !firebase.apps.length) {
  firebase.initializeApp(config);
}

if (USE_EMU) {
  connectEmulators(firebase, plan, EMULATOR_PROJECT_ID);
  // eslint-disable-next-line no-console
  console.log(`[firebase] EMULATOR-Modus aktiv (${EMULATOR_PROJECT_ID}, ${plan.kind === 'secure' ? plan.origin : 'HTTP'}).`);
}

// Analytics im Emulator überspringen (kein measurementId, würde warnen/werfen).
if (!USE_EMU) {
  try {
    firebase.analytics();
  } catch (e) {}
}

export const db = firebase.firestore();
export const rtDB = firebase.database();
export const FieldValue = firebase.firestore.FieldValue;
export const storageRef = firebase.storage().ref();
export const functions = firebase.app().functions('europe-west3');

export default firebase;
